<template>
  <li v-if="pending">
    <span class="loading loading-dots loading-sm" />
  </li>
  <li
    v-else-if="error"
    class="text-error"
  >
    {{ error }}
  </li>
  <template v-else>
    <li class="menu-title">
      {{ table === 'design' ? 'Deine Designs' : 'Deine Texte' }}
    </li>
    <li
      v-for="entry in entries"
      :key="entry.id"
    >
      <NuxtLink
        :to="`/${table === 'design' ? 'design' : 'write'}/${entry.id}`"
        active-class="active"
      >
        {{ entry.title }}
      </NuxtLink>
    </li>
  </template>
</template>

<script setup lang="ts">
import { useDesignList, useTextList } from '~/composables/title-list'

// The designs or texts in the sidebar, each linking to its editor
const props = defineProps<{
  table: 'design' | 'texts'
}>()

const { entries, error, pending, refresh } = props.table === 'design' ? useDesignList() : useTextList()
refresh()
</script>
